/**
 * SpaceBar – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Screen from '@screen';

/** Space bar / keyboard key. */
export default function SpaceBarIcon({ focused }: { focused: boolean }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={77 * Screen.widthRatio}
      height={44 * Screen.widthRatio}
      fill='none'
      viewBox='0 0 77 44'
    >
      <g filter='url(#filter0_d_5986_12937)'>
        <rect
          width='76'
          height='43'
          x='0.5'
          fill={focused ? Colors['key'] : Colors['keyBg']}
          rx='5'
        ></rect>
        <path
          stroke={focused ? 'black' : 'white'}
          strokeWidth='2'
          d='M14.625 16.625V25a3 3 0 0 0 3 3h43a3 3 0 0 0 3-3v-7.5'
        ></path>
      </g>
      <defs>
        <filter
          id='filter0_d_5986_12937'
          width='76'
          height='44'
          x='0.5'
          y='0'
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
          <feColorMatrix
            in='SourceAlpha'
            result='hardAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          ></feColorMatrix>
          <feOffset dy='1'></feOffset>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0'></feColorMatrix>
          <feBlend
            in2='BackgroundImageFix'
            result='effect1_dropShadow_5986_12937'
          ></feBlend>
          <feBlend
            in='SourceGraphic'
            in2='effect1_dropShadow_5986_12937'
            result='shape'
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}
